import { render, staticRenderFns } from "./FraudTypesSection.vue?vue&type=template&id=49a93052&scoped=true"
import script from "./FraudTypesSection.vue?vue&type=script&lang=js"
export * from "./FraudTypesSection.vue?vue&type=script&lang=js"
import style0 from "./FraudTypesSection.vue?vue&type=style&index=0&id=49a93052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a93052",
  null
  
)

export default component.exports